/**
 * INIT
 */

$(document).on('click', 'a[disabled]', function (e) {
    e.preventDefault();
    return false;
});

window.addLoader = function (elt) {
    elt.attr('data-previous-content', elt.html());
    elt.html('<div class="loader">\n' +
        '<div></div>\n' +
        '<div></div>\n' +
        '<div></div>\n' +
        '<div></div>\n' +
        '</div>')
    elt.attr('data-previous-disabled', elt.is(':disabled') ? '1' : '0');
    elt.attr('disabled', 'disabled');
}

window.removeLoader = function (elt) {
    elt.html(elt.attr('data-previous-content'));
    if(parseInt(elt.attr('data-previous-disabled') === 1)) {
        elt.attr('disabled', 'disabled');
    } else {
        elt.removeAttr('disabled');
    }
    elt.removeAttr('data-previous-disabled')
    elt.removeAttr('data-previous-content')
}

/*
 * Ajoute ou met à jour la quantitée d'un produit virtuel dans le panier courant
 */
var set_cart_quantity_xhr = false;
set_cart_quantity = function (deliverie_virtual_product, shipping_date, deliverie_date, deliverie_id, preorder_id, preorder, product_status, product_id, virtual_product_id, quantity, quantity_package, action = 'update', callback = false, unlockMultipeCalls = false, completeCallback = null) {
    let booked_price = null;
    if(document.getElementById('quick-add-to-cart-modal') && document.getElementById("booked_price_"+product_id) && $('#quick-add-to-cart-modal #booked_price_'+product_id).val().match(/^([0-9]+(([.,]{1}[0-9]{1,2})?))?$/)){
        booked_price = !!$('#quick-add-to-cart-modal #booked_price_'+product_id).val() ? $('#quick-add-to-cart-modal #booked_price_'+product_id).val() : 0;
    }else if(document.getElementById("booked_price"+deliverie_id+virtual_product_id)){
        //Pour la mise à jour de la quantité dans la page panier
        booked_price=!!$('.list_products_cart #booked_price'+deliverie_id+virtual_product_id).data('booked_price') ? $('.list_products_cart #booked_price'+deliverie_id+virtual_product_id).data('booked_price') : 0;
    }

    preorder_date_modal_product_shipping='';
    preorder_date_modal_product_delivery='';
    if (can_add_product_to_cart) {
        if (!unlockMultipeCalls && set_cart_quantity_xhr && set_cart_quantity_xhr.readyState != 4) {
            set_cart_quantity_xhr.abort();
        }

        const preorder_date_modal_product = $('#preorder_date_modal_product').children(":selected");
        if(!preorder_date_modal_product_delivery && preorder_date_modal_product){
            preorder_date_modal_product_shipping=preorder_date_modal_product.attr('data-shipping');
            preorder_date_modal_product_delivery=preorder_date_modal_product.attr('data-delivery');
        }

        if(document.getElementById('preorder_date') && !preorder_date_modal_product_shipping && !preorder_date_modal_product_delivery){
            //C'est un produit préco et il y a une date préco
            preorder_date_modal_product_shipping=$('#preorder_date').data('shipping_date');
            preorder_date_modal_product_delivery=$('#preorder_date').data('delivery_date');
            preorder=1;
        }

        set_cart_quantity_xhr = $.ajax({
            url: url_cart_quantity_update,
            method: 'post',
            data: {
                _token: csrf_token,
                virtual_product_id: virtual_product_id,
                quantity: quantity,
                booked_price: booked_price,
                quantity_package: quantity_package,
                deliverie_virtual_product: deliverie_virtual_product,
                shipping_date: shipping_date,
                delivery_date: deliverie_date,
                delivery_id: deliverie_id,
                preorder_id: preorder_id,
                preorder: preorder,
                product_status: product_status,
                preorder_date_shipping: preorder_date_modal_product_shipping,
                preorder_date_delivery: preorder_date_modal_product_delivery,
                action
            },
            dataType: 'json',
            success: function (response) {
                if(!!response.need_reload) window.location.reload();

                if (!!response.summary_cart) {
                    $('.summary-total-cart .total_products_kg .value').html(response.summary_cart.total_products_kg);
                    $('.summary-total-cart .total_qty .value').html(response.summary_cart.total_products_qty);
                    $('.summary-total-cart .total_ht .value').html(response.summary_cart.subtotal_ht);
                    $('.summary-total-cart .cart_total_delivery .value').html(response.summary_cart.cart_total_delivery);
                    $('.summary-total-cart .total .value > span:first-child').html(response.summary_cart.total_ht);
                    $('#content_header .nb_product').text(response.summary_cart.nb_products);
                    if($('#promo_code_value').length){
                        $('#promo_code_value').text(response.marketing_coupons.rebate);
                    }
                }

                if (!!response.delivery) {
                    const shipping_infos = response.delivery.infos;
                    $('#ban_info').text(shipping_infos.ban_info);
                    $('#header .nb_product').show().text(shipping_infos.nb_product)

                    $('.wrapper_delivery .title').html(shipping_infos.ban_info);
                    if ($('.wrapper_delivery .wrapper_marker_statut').length) {
                        $('.wrapper_delivery .wrapper_marker_statut').get(0).style.setProperty('--width', response.delivery.slider_width + '%');
                    }

                    $('.delivery_info .wrapper_delivery .cart').html(shipping_infos.product_info);

                    $('.summary-total-cart .info_free_shipping').text(shipping_infos.ban_info);

                    $('[class*="color_free_shipping_"]').attr('class', function (i, c) {
                        return c.replace(/color_free_shipping_\S+/g, 'color_free_shipping_' + shipping_infos.color_free_shipping)
                    });
                }

                if (!!response.summary_product) {
                    if(deliverie_virtual_product){
                        $('.list_products_cart .product_cart[data-deliverie-virtual-product='+deliverie_virtual_product+'] .price .price_total .value').html(response.summary_product.total_price);
                        weight_product = $('.list_products_cart .product_cart[data-deliverie-virtual-product='+deliverie_virtual_product+'] .total_weight .value .weight_unit');
                    }else{
                        $('.list_products_cart .product_cart[data-virtual-product-id=' + virtual_product_id + '] .price .price_total .value').html(response.summary_product.total_price);
                        weight_product = $('.list_products_cart .product_cart[data-virtual-product-id=' + virtual_product_id + '] .total_weight .value .weight_unit');
                    }

                    if(weight_product.data('unit_u')=='kg'){
                        new_quantity=weight_product.data('weight_u')/1000 * Number(quantity);
                    }else{
                        new_quantity=weight_product.data('weight_u') * Number(quantity);
                    }

                    new_quantity=new_quantity.toFixed(2).replace(/(\.0+|0+)$/, '');

                    if(new_quantity>1){
                        weight_unit=new_quantity+' '+weight_product.data('name_plural');
                    }else{
                        weight_unit=new_quantity+' '+weight_product.data('name_singular');
                    }

                    weight_product.html(weight_unit);
                }

                if (quantity <= 0) {
                    $('.list_products_cart .product_cart[data-deliverie-virtual-product='+deliverie_virtual_product+'] .wrapper_col').css('color','white');
                    $('.list_products_cart .product_cart[data-deliverie-virtual-product='+deliverie_virtual_product+']').fadeOut('quick', function () {
                        this.remove();
                    });
                }

                if (!!callback) {
                    callback(response);
                }
            },
            error: function(xhr, status, error){
                //L'utilisateur n'est plus connecté -> redirection
                if(error!=='abort'){
                    //Abort est l'erreur si le client clique trop vite pour changer la quantité dans le panier
                    window.location.href=url_connection;
                }
            },
            complete: completeCallback,
        });
    }
};

updateCartDetailIfStockProductCallback = function ($productCart) {
    const cart_content = $('#cart_content');
    if (cart_content.length && $productCart.data('stock')) {
        return function () {
            $.ajax({
                url: url_cart_detail_content + '?upd=' + Date.now()+'&ajaxCallProductQuantityChange=true',
                method: 'get',
                dataType: 'html',
                success: function (html) {
                    cart_content.html(html);
                }
            });
        }
    }
    return null;
}

$(document).ready(function () {

    /*
        select 2
    */
    /*window.front_select2_options = {
        minimumResultsForSearch: -1
    };
    $('select').select2(window.front_select2_options);*/

    window.addEventListener('click', function (e) {
        if (ELEMENT_ACTIVE) {
            if (!ELEMENT_ACTIVE.find($(e.target)).length) {
                close_element_active();
            }
        }
    });

    /* Modal de connexion */
    if (!user_is_auth) {
        $(document).on('click', '.show_login_modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('#login_modal').addClass('active');
        });
    }

    /* Modal interdit d'ajout au panier */
    if (user_is_auth) {
        $(document).on('click', '.show_cannot_product_to_cart_modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('#cannot_product_to_cart_modal').addClass('active');
        });
    }

    if(user_is_auth){
        $('.cart_change_date_product').click(function(){
            //Changement de la date de livraison/expédition d'un produit car la date d'expédition est dépassée ou le produit n'est plus disponible
            cart_id=$(this).data('cart_id');
            cart_deliverie_id=$(this).data('cart_deliverie_id');
            cart_virtualproduct_id=$(this).data('cart_virtualproduct_id');
            cart_select_date_product=$("#cart_select_date_product_"+cart_id+"_"+cart_deliverie_id+"_"+cart_virtualproduct_id+" option:selected");

            $.ajax({
                url: url_cart_product_change_date,
                method: 'post',
                data: {
                    _token:csrf_token,
                    cart_id:cart_id,
                    cart_deliverie_id:cart_deliverie_id,
                    cart_virtualproduct_id:cart_virtualproduct_id,
                    delivery_date:cart_select_date_product.data('delivery'),
                    shipping_date:cart_select_date_product.data('shipping')
                },
                dataType: 'json'
            }).done(function(res) {
                if(res.code===200){
                    document.getElementById("cart_change_date_product_error_"+cart_id+"_"+cart_deliverie_id+"_"+cart_virtualproduct_id).style.display="none";
                    location.reload();
                }else{
                    document.getElementById("cart_change_date_product_error_"+cart_id+"_"+cart_deliverie_id+"_"+cart_virtualproduct_id).style.display="block";
                }
            }).fail(function(){
                document.getElementById("cart_change_date_product_error_"+cart_id+"_"+cart_deliverie_id+"_"+cart_virtualproduct_id).style.display="block";
            });
        });
    }

    $(document).on('click', '.disabled', function (e) {
        e.preventDefault();
    });

    /*
    open primary menu
     */
    $('.js-open_nav').click(function (e) {
        if (!$(this).closest('.wrapper_nav').hasClass('active') && !ELEMENT_ACTIVE) {
            $(this).closest('.wrapper_nav').addClass('active');
            ELEMENT_ACTIVE = $(this).closest('.wrapper_nav');
            e.stopPropagation();
        } else {
            $(this).closest('.wrapper_nav').removeClass('active');
            close_element_active();
        }
    });

    $('.links_catalog .item .toggle_sub_nav').click(function () {
        $(this).closest('.item').toggleClass('active');
    });

    /*
    btn back to top in view
     */

    $('.back-to-top').click(function () {
        $("html, body").animate({scrollTop: 0}, 500);
    });

    //Pas de chargement de certains scripts si chargement en ajax via le panier
    if(typeof ajaxCallProductQuantityChange==='undefined' || !ajaxCallProductQuantityChange===true) {
        //Boutons du panier - up and down input qty
        $(document).on('click', '.wrapper_input_qty .down_qty', function () {
            if (!$(this).hasClass('disabled')) {
                var qty = $(this).closest('.wrapper_input_qty').find('.qty');

                if ($(this).hasClass('live')) {
                    //Si le bouton down est sur la page panier
                    if (Number(qty.val()) > Number(qty.attr('max'))) {
                        qty.val(parseInt(qty.attr('max')));
                    } else {
                        qty.val(parseInt(qty.val()) - 1);
                    }
                } else {
                    qty.val(parseInt(qty.val()) - 1);
                }
                qty.trigger('change');
            }
            if (typeof CalculPricePreorderDateModal == 'function') {
                new CalculPricePreorderDateModal();
            }
        });
        //Bouton du panier si trop de quantité pour réduire au maximum disponible en cours du jour
        $(document).on('click', '.btn_cart_change_max_quantity_available', function () {
            var qty = $('#'+$(this).data('cart_product_qty'));
            qty.val(parseInt(qty.attr('max')));
            qty.trigger('change');
            if (typeof CalculPricePreorderDateModal == 'function') {
                new CalculPricePreorderDateModal();
            }
        });

        $(document).on('click', '.wrapper_input_qty .up_qty', function () {
            if (!$(this).hasClass('disabled')) {
                var qty = $(this).closest('.wrapper_input_qty').find('.qty');
                if(Number(qty.val()) == Number(qty.attr('max'))){
                    if($(this).data('packaging-id') && document.getElementById("stockmax_display"+$(this).data('packaging-id'))) {
                        document.getElementById("stockmax_display" + $(this).data('packaging-id')).style.display = "block";
                    }
                }else if(Number(qty.val()) < Number(qty.attr('max'))){
                    qty.val(parseInt(qty.val()) + 1);
                    qty.trigger('change');
                }
            }
            if (typeof CalculPricePreorderDateModal == 'function') {
                new CalculPricePreorderDateModal();
            }
        });
    }
    $(document).on('change', '.wrapper_input_qty .qty', function () {
        if (!$(this).hasClass('disabled')) {
            if (!!$(this).attr('min') && $(this).val() < $(this).attr('min')) {
                if (Number($(this).attr('min')) == 0) {
                    $(this).val(1);
                } else {
                    $(this).val($(this).attr('min'));
                }
            }
        }
        if (typeof CalculPricePreorderDateModal == 'function') {
            new CalculPricePreorderDateModal();
        }
    });
    $(document).on('keyup change', '.product_cart input[name="qty"]', function () {
        if(Number($(this).val())<=Number($(this).attr('max'))) {
            set_cart_quantity($(this).data('deliverieVirtualProduct'), $(this).data('shipping-date'), $(this).data('deliverie-date'), $(this).data('deliverie-id'),'','', 0,'', $(this).data('virtual-product-id'), $(this).val(), $(this).attr('data-quantity_package'), 'update', updateCartDetailIfStockProductCallback($(this).closest('.product_cart')));
        }else{
            set_cart_quantity($(this).data('deliverieVirtualProduct'), $(this).data('shipping-date'), $(this).data('deliverie-date'), $(this).data('deliverie-id'),'','', 0,'', $(this).data('virtual-product-id'), Number($(this).attr('max')), $(this).attr('data-quantity_package'), 'update', updateCartDetailIfStockProductCallback($(this).closest('.product_cart')));
        }
        if (typeof CalculPricePreorderDateModal == 'function') {
            new CalculPricePreorderDateModal();
        }
    });

    /** FIN Boutons du panier **/

    /*
    modal
     */
    $(document).on('click', '.open_modal', function (e) {
        e.preventDefault();

        if (!!$(this).data('before')) {
            $(this).data('before')();
        }
        $($(this).data('target')).toggleClass('active');

        $($(this).data('target')).trigger('modal.show');
    });

    $(document).on('click', '.close_modal,.btn-close_modal', function (e) {
        e.preventDefault();
        $(this).closest('.wrapper_modal').toggleClass('active')
    });


    /**
     * TABS
     */

    $(document).on('click', '.wrapper_tabs .header_tabs .label_tab', function () {
        var id = $(this).data('href')
        $(this).closest('.wrapper_tabs').find('.content_tab').removeClass('active')
        $(this).closest('.wrapper_tabs').find('.label_tab').removeClass('active')
        $(this).closest('.wrapper_tabs').find('#' + id).addClass('active');
        $(this).addClass('active');
    })

    /*
    Slick slider for listing last product view
     */
    if ($('.wrapper_last_product_view .products_list').length) {
        $('.wrapper_last_product_view .products_list').slick({
            dots: false,
            speed: 500,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                }
            ]
        });
    }

    /*
    event wishlist elements
     */

//show add product to wishlist
    $(document).on('click', '.add_wishlist', function () {
        if (!$(this).hasClass('disabled')) {
            getFormSelectWishlist($(this).data('product_id'));
        }
    });

    $(document).on('click', '.close_modal_wishlist', function () {
        $('.modal_wishlist').remove();
    })

//after submit  form select wishlist
    $(document).on('click', '.content_select_wishlist .submit_add_wishlist', function () {
        document.getElementById('wrapper_listing_form').style.display='none';
        document.getElementById('wrapper_list_loading').style.display='block';
        document.getElementById('wrapper_list_info').style.display='block';
        document.getElementById('wrapper_list_info').style.display='none';

        product_id=$(this).data('product_id');
        if(product_id){
            select_wishlist=$("#select_wishlist").val();
            if(!select_wishlist){
                select_wishlist=[];
            }
            new_wishlist_name=$("#new_wishlist_name").val();
            if(!new_wishlist_name){
                new_wishlist_name='';
            }
            $.ajax({
                method: "POST",
                url: AJAX_SAVEPRODUCTTOWISHLIST_URL,
                data: {
                    _token: csrf_token,
                    wishlists_selected: select_wishlist,
                    product_id: product_id,
                    wishlist_name: new_wishlist_name
                },
                dataType: 'json'
            }).done(function (res) {
                if(res.product_wishlist){
                    if(res.product_wishlist==='in_wishlist'){
                        $(".add_wishlist[data-product_id='"+product_id+"'] > .icon-heart").removeClass('icon-heart').addClass('icon-heart-full');
                    }else{
                        $(".add_wishlist[data-product_id='"+product_id+"'] > .icon-heart-full").removeClass('icon-heart-full').addClass('icon-heart');
                    }
                }
                if (res.code === 200) {
                    getConfirmWishlist();
                } else {
                    document.getElementById('wrapper_listing_form').style.display='block';
                    document.getElementById('wrapper_list_loading').style.display='none';
                    $('#wrapper_list_info').html('<div class="p-2 mb-2 bg-warning text-white text-center" style="z-index: 1;">'+AJAX_SAVEPRODUCTTOWISHLIST_ERROR+'</div>');
                    document.getElementById('wrapper_list_info').style.display='block';
                }
            });
        }
    });

    $(document).on('click', '.content_create_wishlist .submit_add_wishlist', function () {
        var form = $(this).closest('.content_modal');
        $.ajax({
            method: "POST",
            url: AJAX_CREATEWISHLIST_URL,
            data: {
                _token: csrf_token,
                wishlist_id: form.find('[name=wishlist_id]').val(),
                wishlist_name: form.find('[name=new_wishlist_name]').val()
            },
            dataType: 'json'
        }).done(function (res) {
            if (res.code == 200) {
                location.reload();
            } else {
                console.info('Error', res);
            }
        });
    });

//show create new wishlist
    $(document).on('click', '#new_wishlist_name', function () {
        $(this).closest('.item').find('#wishlist_new').prop("checked", true);
    });

// click icon datepicker

    $(document).on('click', '.wrapper_datepicker .icon-calendar', function () {
        $(this).closest('.wrapper_datepicker').toggleClass('active')
    })

// collapse
    $(document).on('click', '.wrapper_collapse .label_collapse', function () {
        $(this).closest('.wrapper_collapse').toggleClass('active')
    })


    let qatcm_get_product_xhr = false;
    const $modal = $('#quick-add-to-cart-modal');
    const $modal_content = $modal.children('.content_modal').first();

    let initial_modal_bottom_position;
    $modal_content.draggable({
        axis: 'y',
        handle: '.drag-cuff-wrapper',
        start: function (e, ui) {
            $modal_content.css('transition', 'none');
            initial_modal_bottom_position = $(window).height() - $modal_content.position().top - $modal_content.height();
        },
        drag: function (e, ui) {
            // Si pas mobile, on bloque
            if ($(window).width() > 768) {
                return false;
            }

            if (ui.position.top > 1) {
                $modal.addClass('deported-shadow');
            } else {
                $modal.removeClass('deported-shadow');
            }

            // On empêche la modale d'être drag vers le haut
            ui.position.top = Math.max(0, ui.position.top);
        },
        stop: function (e, ui) {
            $modal.removeClass('deported-shadow');
            $modal_content.css('transition', '');

            // Si moins de la moitié, on remonte la modale
            if (ui.position.top < (initial_modal_bottom_position / 2)) {
                $modal_content.css('top', '0');
            } else { // Sinon, on fini de la descendre puis on la ferme
                $modal_content.css('top', $modal_content.height());
                setTimeout(function () {
                    $modal.removeClass('active');
                    $modal_content.css('top', '0');
                }, 200);
            }
        }
    });

    const qcmUpdateVariation = function () {
        const packaging_elt = $('#quick-add-to-cart-modal select[name="packaging_id"]');
        if(document.getElementById('packaging_id_modal')) {
            var packaging_id = document.getElementById('packaging_id_modal').value;
            var label_id = document.getElementById('label_id_modal').value;
            const $qty = $('#quick-add-to-cart-modal .wrapper_quantity .qty');

            //Cache des labels qui n'ont pas de produit virtuel (conditionnement) car ils n'ont pas un prix différent de sans label
            let selectElement = document.getElementById('label_id_modal');
            if (selectElement) {
                let optionNames = [...selectElement.options].map(o => o.value);
                optionNames.forEach((value_label, index) => {
                    if (value_label && value_label != 5) {
                        count_nb_packagings_label = $('#packaging_id_modal option[data-label="' + value_label + '"]').length;
                        if(!count_nb_packagings_label){
                            $("#label_id option").each(function(){
                                if($(this).val()==value_label){
                                    $(this).prop("hidden","hidden");
                                }
                            });
                        }
                        if(count_nb_packagings_label==0){
                            document.getElementById('bloc_select_label').style.display = 'none';
                            $("#label_id").prop("selectedIndex", 1);
                        }
                    }
                });
            }

            //Nombre de conditionnements total
            count_nb_packagings = ($('#packaging_id_modal option').length) - 1;

            //Nombre de conditionnements total pour un label aucun
            count_nb_packagings_label_empty = $('#packaging_id_modal option[data-label="5"]').length;

            let qty = $qty.val();
            if (!!$qty.attr('min') && $qty.val() < $qty.attr('min')) {
                qty = $qty.attr('min');
            } else if (parseFloat($qty.val()) > parseFloat($qty.attr('max'))) {
                qty = $qty.attr('max');
                $qty.val(qty);
            }

            nb_packaging = 1;
            nb_packaging_hide = 1;

            packaging_elt.find('option').each(function () {
                const target_label = $(this).attr('data-label');
                if (label_id && target_label) {
                    //Un label est sélectionné
                    if (target_label == label_id) {
                        //Le conditionnement fait partie du label sélectionné
                        if ($(this).attr('data-stock') && $(this).attr('data-stock') > 0) {
                            //Le conditionnement a un stock
                            $(this).prop('disabled', false);
                            $(this).prop('hidden', false);
                        } else {
                            $(this).prop('disabled', 'disabled');
                            $(this).prop('hidden', false);
                        }
                    } else {
                        $(this).prop('disabled', 'disabled');
                        $(this).prop('hidden', 'hidden');
                    }
                } else {
                    if (target_label && count_nb_packagings != count_nb_packagings_label_empty && nb_packaging == nb_packaging_hide) {
                        //Il y a plusieurs labels -> un conditionnement sur deux est caché quand aucun label est sélectionné
                        nb_packaging += 1;
                        nb_packaging_hide += 2;
                        $(this).prop('disabled', false);
                        $(this).prop('hidden', 'hidden');
                    } else {
                        //Aucun conditionnement de caché quand aucun label est sélectionné car il y a qu'un seul label
                        $(this).prop('disabled', false);
                        $(this).prop('hidden', false);
                        $(this).removeClass('hide');
                    }
                }
            })
            packaging_elt.find('option:selected').each(function () {
                if ($(this).attr('data-unit') === '2') {
                    document.getElementById('modal_quantity_package_display').style.display = 'block';
                } else {
                    document.getElementById("modal_quantity_package").checked = false;
                    document.getElementById('modal_quantity_package_display').style.display = 'none';
                }
                if ($(this).prop('disabled')) {
                    $(this).prop('selected', false);
                    var current = $(this);
                    var target_default = null;
                    var target = null;
                    packaging_elt.find('option:not([disabled])').each(function () {
                        if ($(this).val() != '') {
                            if (target === null && $(this).val() === current.val()) {
                                target = $(this);
                            }
                            if (target_default === null) {
                                target_default = $(this);
                            }
                        }
                    });
                    if (target === null) target = target_default;
                    if (target === null) packaging_elt.val(''); // Default option
                    else {
                        target.prop('selected', 'selected')
                    }
                }
            })

            if (!packaging_id || packaging_id.length === 0) {
                packaging_id = packaging_elt.val();
            }
            if (!label_id || label_id.length === 0) {
                label_id = 5;
            }

            setTimeout(() => {
                //100ms pour que les données soient chargées dans la modale (si ouverture de plusieurs modales à la suite les données du produit précédent peuvent être encore présentes)
                if (!!qatcmVariations[packaging_id] && !!qatcmVariations[packaging_id][label_id]) {
                    const qatcmVariation = qatcmVariations[packaging_id][label_id];
                    const $delivery_info_total_qty = $('#quick-add-to-cart-modal .delivery_info_total .qty');
                    const $delivery_info_total_weight = $('#quick-add-to-cart-modal .delivery_info_total .weight');

                    qatcm_selected_variation_id = qatcmVariation.id;

                    if (document.getElementById('preorders_date')) {
                        //C'est une modal de précommande
                        if ($("#preorder_date").children("option:selected").data('price') && $("#preorder_date").children("option:selected").data('price') !== 0) {
                            if (qatcmVariation.packaging && qatcmVariation.packaging.quantity === 1 && qatcmVariation.weight) {
                                new_price = formatMoney($("#preorder_date").children("option:selected").data('price') * qty * (qatcmVariation.weight / 1000));
                            } else {
                                if (qatcmVariation.packaging && qatcmVariation.packaging.quantity) {
                                    new_price_quantity = qatcmVariation.packaging.quantity;
                                } else {
                                    new_price_quantity = 1;
                                }
                                new_price = formatMoney($("#preorder_date").children("option:selected").data('price') * qty * new_price_quantity);
                            }

                            $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(new_price);
                            $("#deliveryDatepicker").on("change", function () {
                                $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(new_price);
                            });
                            $("#display_price_unit").removeClass('hidden');
                            $("#display_price_unit_value").text(formatMoney($("#preorder_date").children("option:selected").data('price')) + '/' + $("#packaging_id_modal option:selected").data('unit_name_singular'));
                        } else if ($("input#preorder_date")) {
                            //C'est une modal de précommande via un filtre catalogue
                            if (qatcmVariation.packaging.quantity == 1) {
                                new_price = formatMoney($("input#preorder_date").data('packaging_' + qatcmVariation.packaging_id) * qty * (qatcmVariation.weight / 1000));
                            } else {
                                new_price = formatMoney($("input#preorder_date").data('packaging_' + qatcmVariation.packaging_id) * qty * qatcmVariation.packaging.quantity);
                            }

                            $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(new_price);
                            $("#deliveryDatepicker").on("change", function () {
                                $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(new_price);
                            });
                            $("#display_price_unit").removeClass('hidden');
                            $("#display_price_unit_value").text(formatMoney($("input#preorder_date").data('packaging_' + qatcmVariation.packaging_id)) + '/' + $("#packaging_id_modal option:selected").data('unit_name_singular'));
                        } else {
                            $("#display_price_unit").addClass('hidden');
                        }
                    } else if (document.getElementById("total_price")) {
                        //C'est une modale d'achat préco
                        if (qatcmVariation.packaging.quantity == 1) {
                            new_price = formatMoney($('#total_price').data('preorder_price') * qty * (qatcmVariation.weight / 1000));
                        } else {
                            new_price = formatMoney($('#total_price').data('preorder_price') * qty * qatcmVariation.packaging.quantity);
                        }
                        $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(new_price);
                    } else {
                        //C'est une modal d'achat classique
                        if(qty==0){
                            //Force la quantité à 1 si elle est vide au chargement de la modale c'est pour l'auto sélection du premier conditionnement
                            qty=1;
                        }
                        $('#quick-add-to-cart-modal .btn_addtocart .total-price').text(formatMoney(qatcmVariation.unitPrice * qty));
                    }

                    let qty_text = $delivery_info_total_qty.data('sg');
                    if (qty > 1) {
                        qty_text = $delivery_info_total_qty.data('pl');
                    }

                    if (document.getElementById('modal_quantity_package').checked || qatcmVariation.packaging_unit.type == 0) {
                        //Si case conditionnement individuel coché ou type d'unité kg
                        $delivery_info_total_qty.text(qty_text.replace(/[0-9]+/ig, qty));
                    } else {
                        $delivery_info_total_qty.text(qty_text.replace(/[0-9]+/ig, 1));
                    }

                    if (qatcmVariation.packaging && qatcmVariation.packaging.weight) {
                        /* Calcul du poids après le message "Total sur ce produit" */
                        if(qatcmVariation.packaging.quantity==0){
                            //Si la quantité de conditionnement est 0 c'est une erreur ça doit être 1
                            VariationPackagingQuantity=1;
                        }else{
                            VariationPackagingQuantity=qatcmVariation.packaging.quantity;
                        }
                        VariationPackagingWeight=parseFloat(qatcmVariation.packaging.weight) / 1000 * qty * VariationPackagingQuantity;
                        $delivery_info_total_weight.text($delivery_info_total_weight.text().replace(/[0-9]*(\.|,)?[0-9]+/ig, VariationPackagingWeight.toFixed(2).replace(/(\.0+|0+)$/, '')));
                        $('#quick-add-to-cart-modal .delivery_info_total').show();
                    }
                } else {
                    qatcm_selected_variation_id = null;
                    $('#quick-add-to-cart-modal .btn_addtocart .price').text('');
                    $('#quick-add-to-cart-modal .delivery_info_total').hide();
                }
            }, 100);
        }
    }

    const deferQatcmVariations = function (callback) {
        if (!qatcmVariations) {
            setTimeout(() => {
                deferQatcmVariations(callback);
            }, 100);
        } else {
            callback();
        }
    }

    $(document).on('click', '.quick-add-to-cart-btn:not(.disabled)', function (e) {
        const id_product = $(this).data('id_product');
        const page = $(this).data('page');
        const event_type = $(this).data('event_type');
        const event_id = $(this).data('event_id');
        const preorder_id = $(this).data('preorder_id');
        const preorders_date = $(this).data('preorders_date');

        if(page==='event'){
            if(event_type===1){
                //La modal est affichée depuis une page event avec préco
                type_modal='event_preco';
            }else{
                //La modal est affichée depuis une page event avec cours du jour
                type_modal='event_todaycourse';
            }
        }else if(preorders_date){
            //La modal est affichée depuis le catalog avec une date de précommande
            type_modal='catalog_preorder';
        }else{
            //La modal est affichée depuis une page autre que event
            type_modal='other';
        }

        if (!!id_product) {
            if (qatcm_get_product_xhr && qatcm_get_product_xhr.readyState !== 4) {
                qatcm_get_product_xhr.abort();
            }

            const $this = $(this);
            addLoader($this);

            qatcm_get_product_xhr = $.ajax({
                method: 'post',
                url: QATCM_AJAX_GET_PRODUCT_URL+'/?_token=' + csrf_token,
                data: {'id_product': id_product, 'is_reorder': (!!$(this).data('is_reorder') ? '/1' : ''), 'preorder':preorder_id, 'preorders_date':preorders_date},
                success: function (html) {
                    if(html.slice(0,4)!=='<div'){
                        //Si le retour html ne commence pas par <div il y a une erreur de connexion -> redirection page connexion (évite d'afficher la page de connexion en modale)
                        window.location.replace(url_connection);
                    }else{
                        //Sinon affichage de la modale d'ajout au panier
                        $modal_content.html(html);
                        $modal.addClass('active');
                        // En cas de préselection
                        deferQatcmVariations(qcmUpdateVariation);
                    }
                },
                error: function (){
                    //Utilisateur déconnecté sur une autre page, utilisateur désactivé ou utilisateur sans société -> redirigé sur la page de connexion
                    window.location.replace(url_connection);
                },
                complete: function () {
                    removeLoader($this)
                }
            });
        }
    });

    $(document).on('keyup change', '#quick-add-to-cart-modal select.variation_input, #quick-add-to-cart-modal input[name="qty"], #modal_quantity_package', function () {
        $('#quick-add-to-cart-modal .message_submit').hide();
        $('#quick-add-to-cart-modal .bloc_select.error').removeClass('error');
        qcmUpdateVariation();
        if (typeof CalculPricePreorderDateModal == 'function') {
            new CalculPricePreorderDateModal();
        }
    });

// /* Add to cart */
    $(document).on('click', '#quick-add-to-cart-modal .btn_addtocart', function () {
        qcmUpdateVariation();
        if (!$(this).hasClass('disabled')) {
            let element_errors = [];

            var qty = $('#quick-add-to-cart-modal .wrapper_quantity .qty').val();
            if (!qatcm_selected_variation_id) {
                const packaging_id = $('#quick-add-to-cart-modal select[name="packaging_id"]').val();

                if (!!packaging_id) {
                    element_errors.push($('#quick-add-to-cart-modal .message_submit.combination'));
                    $('#quick-add-to-cart-modal select[name="label_id"]').parent().addClass('error');
                } else {
                    element_errors.push($('#quick-add-to-cart-modal .message_submit.packaging'));
                }
                $('#quick-add-to-cart-modal select[name="packaging_id"]').parent().addClass('error');
            }

            quantity_package='';
            if(document.getElementById('modal_quantity_package') && (document.getElementById('modal_quantity_package').checked || $('#packaging_id_modal').children(":selected").data('unit')==0)){
                quantity_package=1;
            }

            if (element_errors.length) {
                element_errors.forEach(el => {
                    el.show();
                })
            } else {
                const $this = $(this);
                addLoader($this);

                //Récupération de la date de livraison/expédition via le select de date ou l'input date
                delivery_date='';
                shipping_date='';
                preorder_id='';
                preorder='';
                if(document.getElementById('preorder_date')){
                    if(document.getElementById('preorder_dates')){
                        shipping_date=$("#preorder_date").find(':selected').data("shipping");
                        delivery_date=$('#preorder_dates select[name="date"]').val();
                    }else{
                        preorder_date=$('#preorder_date');
                        shipping_date=preorder_date.data('shipping_date');
                        delivery_date=preorder_date.data('delivery_date');
                    }
                    preorder_id=$("#preorder_id").val();
                    preorder=$("#preorder").val();
                }

                product_id='';
                if($('#quick-add-to-cart-modal .wrapper_quantity .qty').data('product-id')){
                    //Utilisé pour la préco sans prix
                    product_id=$('#quick-add-to-cart-modal .wrapper_quantity .qty').data('product-id');
                }

                set_cart_quantity('',shipping_date,delivery_date, 0,preorder_id,preorder,0,product_id,qatcm_selected_variation_id, qty, quantity_package, 'add', function (response) {
                    if (!!response.modal) {
                        $modal.removeClass('active');
                        $('main').after(response.modal);
                    }
                }, false, function () {
                    removeLoader($this);
                });
            }
        }
    });

    $(document).on('click', '.front-modal .modal-header .close, .front-modal .modal-footer .close, .front-modal .modal-header .close span, .front-modal', function (e) {
        if(this==e.target) {
            $(this).closest('.front-modal').removeClass('show');
        }
    })
});

/**
 * Input type material
 */
const FloatLabel = (() => {

    // add active class and placeholder
    const handleFocus = (e) => {
        const target = e.target;
        target.parentNode.classList.add('active');
        if (target.getAttribute('data-placeholder'))
            target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
    };

    // remove active class and placeholder
    const handleBlur = (e) => {
        const target = e.target;

        //Pas de suppression du placeholder dans le formulaire de souhait, newsletter footer, code promo panier et montant max réservable
        const id_not_hide_placeholder = ["wishes_presentation", "wishes_caliber", "wishes_weight", "wishes_price", "nl-email", "coupon","booked_price"];
        if(!id_not_hide_placeholder.includes(target.id)){
            if (!target.value) {
                target.parentNode.classList.remove('active');
            }
            target.removeAttribute('placeholder');
        }
    };

    // remove active class and placeholder
    const handleChange = (e) => {
        const target = e.target;
        if (target.hasAttribute('required')) {
            if (target.checkValidity()) {
                target.parentNode.classList.add('valid');
                target.parentNode.classList.remove('error');
            } else {
                target.parentNode.classList.remove('valid');
                target.parentNode.classList.add('error');
            }

        }
    };

    // register events
    const bindEvents = (element) => {
        if (element.getElementsByTagName('select').length)
            var floatField = element.querySelector('select');
        else if (element.getElementsByTagName('input').length)
            var floatField = element.querySelector('input');

        floatField.addEventListener('focus', handleFocus);
        floatField.addEventListener('blur', handleBlur);
        floatField.addEventListener('change', handleChange);
    };

    // get DOM elements
    const init = () => {
        const floatContainers = document.querySelectorAll('.float-container');

        floatContainers.forEach((element) => {

            if (element.getElementsByTagName('select').length) {
                if (element.querySelector('select').value) {
                    element.classList.add('active');
                }
                bindEvents(element);
            }
            if (element.getElementsByTagName('input').length) {
                if (element.querySelector('input').value || element.querySelector('input').placeholder) {
                    element.classList.add('active');
                }

                if (element.querySelector('input').value && element.querySelector('input').hasAttribute('required')) {
                    if (element.querySelector('input').checkValidity())
                        element.classList.add('valid');
                    else
                        element.classList.add('error');
                }
                bindEvents(element);
            }

        });
    };

    return {
        init: init
    };
})();

FloatLabel.init();


/**
 * Init tarte au citron
 */
tarteaucitron.init({
    "privacyUrl": "", /* Privacy policy url */
    "bodyPosition": "bottom", /* or top to bring it as first element for accessibility */

    "hashtag": "#cookies", /* Open the panel with this hashtag */
    "cookieName": "tarteaucitron", /* Cookie name */

    "orientation": "middle", /* Banner position (top - bottom) */

    "groupServices": false, /* Group services by category */
    "serviceDefaultState": "wait", /* Default state (true - wait - false) */

    "showAlertSmall": false, /* Show the small banner on bottom right */
    "cookieslist": true, /* Show the cookie list */

    "closePopup": false, /* Show a close X on the banner */

    "showIcon": true, /* Show cookie icon to manage cookies */
    //"iconSrc": "", /* Optionnal: URL or base64 encoded image */
    "iconPosition": "BottomRight", /* BottomRight, BottomLeft, TopRight and TopLeft */

    "adblocker": false, /* Show a Warning if an adblocker is detected */

    "DenyAllCta": true, /* Show the deny all button */
    "AcceptAllCta": true, /* Show the accept all button when highPrivacy on */
    "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */

    "handleBrowserDNTRequest": true, /* If Do Not Track == 1, disallow all */

    "removeCredit": true, /* Remove credit link */
    "moreInfoLink": true, /* Show more info link */

    "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
    "useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */

    //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

    "readmoreLink": "", /* Change the default readmore link */

    "mandatory": true, /* Show a message about mandatory cookies */
    "mandatoryCta": true /* Show the disabled accept button when mandatory on */
});

tarteaucitron.user.googletagmanagerId = 'GTM-T6L6JHS';
(tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
if(!readCookie('analytics_no')) {
    (tarteaucitron.job = tarteaucitron.job || []).push('analytics');
}
(tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
(tarteaucitron.job = tarteaucitron.job || []).push('sendinblue');

/*
wishlist
 */

let getFormSelectWishlist = function (product_id, packaging_id) {

    $.ajax({
        method: "POST",
        url: AJAX_SELECTWISHLIST_URL,
        data: {
            _token: csrf_token,
            product_id: product_id,
        }
    }).done(function (res) {
        if(res.slice && res.slice(0,9)==='<!DOCTYPE'){
            //Si le retour html commence par <!DOCTYPE il y a une erreur de connexion -> redirection page connexion
            window.location.replace(url_connection);
        }else{
            $('.modal_wishlist').remove();
            $('main').after(res.view);
            setTimeout(FloatLabel.init(), 300);
        }
    });
}

let getConfirmWishlist = function () {
    $.ajax({
        method: "GET",
        url: AJAX_CONFIRMWISHLIST_URL,
        data: {}
    }).done(function (res) {
        $('.modal_wishlist').remove();
        $('main').after(res.view);
    });
}

$(document).on('click', '.content_confirm_add_to_cart .close_modal', function (e) {
    e.preventDefault();
    location.reload();
});

$(document).on('click', '.wrapper_modal', function (e) {
    $(this).removeClass('active');

    if ($(this).hasClass('modal_add_to_cart')) {
        location.reload();
    }
});

$(document).on('click', '.content_modal', function (e) {
    e.stopPropagation();
});

$(document).on('click', '.select_customer_btn', function (e) {
    e.preventDefault();
    $('#select_customer_modal').addClass('active');
});


function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function modalWelcome() {
    $.ajax({
        url: url_modal_intro+'?_token=' + csrf_token,
        method: 'post',
        cache: true,
        success: function (response) {
            $('#footer').append(response);
            $("#intro_modal").addClass('active');
            if ($('#intro_modal .wrapper_modale').length) {
                $('#intro_modal .wrapper_modale').slick({
                    dots: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                });
                $('#intro_modal .wrapper_modale').on('init afterChange', function (e, slick) {
                    let currentSlick = $('.slick-current.slick-active', slick.$slideTrack);
                    let index = currentSlick.data('slick-index');
                    $('#intro_modal .content_modal .footer .btn').removeClass('js-close');
                    if (index == '0') {
                        var txt = $('#intro_modal .content_modal .footer .btn').data('txt_0');
                    } else if (index == '6') {
                        var txt = $('#intro_modal .content_modal .footer .btn').data('txt_6');
                        $('#intro_modal .content_modal .footer .btn').addClass('js-close');
                    } else {
                        var txt = $('#intro_modal .content_modal .footer .btn').data('txt');
                    }
                    $('#intro_modal .content_modal .footer .btn').html(txt);
                });

                $(document).on('click', '#intro_modal .content_modal .footer .btn', function () {
                    if ($(this).hasClass('js-close')) {
                        hide_modal_into()
                    }
                    $('#intro_modal .wrapper_modale').slick('slickNext');
                });
            }
        }
    });
}
$(document).on('click','.js-open_intro',function(e){
    modalWelcome();
});


var url = new URL(document.URL);
/* Commenté pour éviter que la modale de bienvenue soit chargée au chargement du site
var name_popup = url.searchParams.get("popup");
if(name_popup === "bienvenue"){
    $(document).ready(function() {
        modalWelcome();
    });
}

if (!user_is_auth) {
    if(!window.location.pathname.includes('configuration-mot-de-passe') && !window.location.pathname.includes('inscription') && !window.location.pathname.includes('mot-de-passe-oublie')){
        $(document).ready(function() {
            if(readCookie('modale_intro') !== "1") {
                modalWelcome();
                createCookie('modale_intro','1',232);
            }
        });
    }
}*/

function hide_modal_into(){
    $("#intro_modal").removeClass('active');
}
